import {
  FETCH_FRANCHISES,
  FETCH_FRANCHISES_SUCCESS,
  FETCH_FRANCHISES_FAILED,
  EDIT_FRANCHISE,
  EDIT_FRANCHISE_SUCCESS,
  EDIT_FRANCHISE_FAILED,
  ADD_FRANCHISE,
  ADD_FRANCHISE_SUCCESS,
  ADD_FRANCHISE_FAILED,
  DELETE_FRANCHISE,
  DELETE_FRANCHISE_SUCCESS,
  DELETE_FRANCHISE_FAILED,
  ADD_FRANCHISE_ADMIN,
  ADD_FRANCHISE_ADMIN_FAILED,
  REMOVE_FRANCHISE_ADMIN,
  REMOVE_FRANCHISE_ADMIN_FAILED,
} from "../store/types";

import { firebase } from "../config/configureFirebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import store from "../store/store";
import AccessKey from "../other/AccessKey";

const handleResponse = async (response) => {
  const json = await response.json();
  if (!response.ok) {
    throw new Error(
      json.error?.message || json.message || "Unknown error occurred"
    );
  }
  return json;
};

const API_BASE_URL = "https://us-central1-urbaapp.cloudfunctions.net";

export const fetchFranchises = () => async (dispatch) => {
  const functions = getFunctions(firebase.app);
  const getFranchisesFunction = httpsCallable(functions, "getFranchises");

  dispatch({
    type: FETCH_FRANCHISES,
    payload: null,
  });

  try {
    const result = await getFranchisesFunction();
    const franchises = result.data || [];

    dispatch({
      type: FETCH_FRANCHISES_SUCCESS,
      payload: franchises,
    });
  } catch (error) {
    console.error("Error fetching franchises:", error);
    dispatch({
      type: FETCH_FRANCHISES_FAILED,
      payload: error.message || "Error al obtener franquicias",
    });
  }
};

export const getFranchise = (id) => async (dispatch) => {
  const functions = getFunctions(firebase.app);
  const getFranchiseFunction = httpsCallable(functions, "getFranchise");

  dispatch({
    type: FETCH_FRANCHISE,
    payload: null,
  });

  try {
    const result = await getFranchiseFunction({ franchiseId: id });
    const franchise = result.data || {};

    dispatch({
      type: FETCH_FRANCHISE_SUCCESS,
      payload: franchise,
    });

    return franchise;
  } catch (error) {
    console.error("Error fetching franchise:", error);
    dispatch({
      type: FETCH_FRANCHISE_FAILED,
      payload: error.message || "Error al obtener franquicia",
    });

    throw error;
  }
};

export const addFranchise = (franchise) => async (dispatch) => {
  const functions = getFunctions(firebase.app);
  const createFranchiseFunction = httpsCallable(functions, "createFranchise");

  dispatch({
    type: ADD_FRANCHISE,
    payload: null,
  });

  console.log("franchise", franchise);

  try {
    const franchiseData = {
      ...franchise,
      latitude: Number(franchise.latitude),
      longitude: Number(franchise.longitude),
      coverage_radius_km: Number(franchise.coverage_radius_km),
      created_at: Date.now(),
      updated_at: Date.now(),
      status: franchise.status || "active",
    };

    console.log("franchiseData", franchiseData);

    const result = await createFranchiseFunction(franchiseData);

    dispatch({
      type: ADD_FRANCHISE_SUCCESS,
      payload: result.data,
    });

    return result.data;
  } catch (error) {
    console.error("Error adding franchise:", error);
    dispatch({
      type: ADD_FRANCHISE_FAILED,
      payload: error.message || "Error al añadir franquicia",
    });

    throw error;
  }
};

export const editFranchise = (franchise, id) => async (dispatch) => {
  const functions = getFunctions(firebase.app);
  const updateFranchiseFunction = httpsCallable(functions, "updateFranchise");

  dispatch({
    type: EDIT_FRANCHISE,
    payload: null,
  });

  try {
    // Aseguramos que los campos numéricos sean números
    const franchiseData = {
      ...franchise,
      latitude: Number(franchise.latitude),
      longitude: Number(franchise.longitude),
      coverage_radius_km: Number(franchise.coverage_radius_km),
      updated_at: Date.now(),
    };

    const result = await updateFranchiseFunction({
      franchiseId: id,
      franchiseData: franchiseData,
    });

    dispatch({
      type: EDIT_FRANCHISE_SUCCESS,
      payload: result.data,
    });

    return result.data;
  } catch (error) {
    console.error("Error editing franchise:", error);
    dispatch({
      type: EDIT_FRANCHISE_FAILED,
      payload: error.message || "Error al editar franquicia",
    });

    throw error;
  }
};

export const deleteFranchise = (id) => async (dispatch) => {
  const functions = getFunctions(firebase.app);
  const deleteFranchiseFunction = httpsCallable(functions, "deleteFranchise");

  dispatch({
    type: DELETE_FRANCHISE,
    payload: null,
  });

  try {
    const result = await deleteFranchiseFunction({ franchiseId: id });

    dispatch({
      type: DELETE_FRANCHISE_SUCCESS,
      payload: { id, data: result.data },
    });

    return result.data;
  } catch (error) {
    console.error("Error deleting franchise:", error);
    dispatch({
      type: DELETE_FRANCHISE_FAILED,
      payload: error.message || "Error al eliminar franquicia",
    });

    throw error;
  }
};

export const getFranchiseAdmins = (id) => async (dispatch) => {
  try {
    console.log("Fetching franchise admins for ID:", id);
    const functions = getFunctions(firebase.app);
    const getFranchiseAdminsFunction = httpsCallable(
      functions,
      "getFranchiseAdmins"
    );

    const result = await getFranchiseAdminsFunction({ franchiseId: id });

    const admins = result.data;
    dispatch({ type: "SET_FRANCHISE_ADMINS", payload: admins });
    return admins;
  } catch (error) {
    console.error("Error fetching franchise admins:", error);
    dispatch({ type: "FETCH_FRANCHISE_ADMINS_ERROR", payload: error.message });
  }
};

export const addFranchiseAdmin = (franchiseId, userId) => async (dispatch) => {
  const functions = getFunctions(firebase.app);
  const addFranchiseAdminFunction = httpsCallable(
    functions,
    "addFranchiseAdmin"
  );

  dispatch({
    type: ADD_FRANCHISE_ADMIN,
    payload: null,
  });

  try {
    const result = await addFranchiseAdminFunction({ franchiseId, userId });
    return result.data;
  } catch (error) {
    console.error("Error adding franchise admin:", error);
    dispatch({
      type: ADD_FRANCHISE_ADMIN_FAILED,
      payload: error.message || "Error al añadir administrador de franquicia",
    });
    throw error;
  }
};

export const removeFranchiseAdmin =
  (franchiseId, userId) => async (dispatch) => {
    const functions = getFunctions(firebase.app);
    const removeFranchiseAdminFunction = httpsCallable(
      functions,
      "removeFranchiseAdmin"
    );

    dispatch({
      type: REMOVE_FRANCHISE_ADMIN,
      payload: null,
    });

    try {
      const result = await removeFranchiseAdminFunction({
        franchiseId,
        userId,
      });
      return result.data;
    } catch (error) {
      console.error("Error removing franchise admin:", error);
      dispatch({
        type: REMOVE_FRANCHISE_ADMIN_FAILED,
        payload:
          error.message || "Error al eliminar administrador de franquicia",
      });
      throw error;
    }
  };
